module.exports = __webpack_public_path__ + "static/media/open-account-logout.43531ae4.svg";